<template>
  <div class="item">
    <div class="thumbnail">
      <img v-if="video.thumbnail_url" :src="video.thumbnail_url" :alt="video.title">
      <div v-else-if="isAiVideo" class="ai-video-thumbnail">
        <IconWrapper name="cameraPrimaryIcon" :icon-height="44" />
      </div>
      <div v-else class="placeholder">
        <IconWrapper name="uploadVideoLightIcon" :icon-height="28" />
      </div>
    </div>
    <div class="info">
      <PanelItemTitle :title="video.title" :is-ai-video="isAiVideo" />
      <p class="status">{{ statusText }}</p>
    </div>

    <div class="actions">
      <div class="icon" :class="{ 'is-spinning': isProcessing }">
        <IconWrapper v-if="statusIcon" :name="statusIcon" :icon-height="24" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { IconWrapper } from '@/components/common'
import { ProcessingVideo } from '@/services/videos/types'
import { useProcessingPanelItem } from '@/composables/useProcessingPanelItem/useProcessingPanelItem'
import PanelItemTitle from './PanelItemTitle.vue'

const props = defineProps<{
  video: ProcessingVideo
}>()

const { statusText, statusIcon, isProcessing, isAiVideo } =
  useProcessingPanelItem(toRef(props, 'video'))
</script>

<style scoped lang="scss">
.item {
  display: flex;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid $display-neutrals-300;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: $display-neutrals-100;
  }
}

.thumbnail {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.ai-video-thumbnail {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  // :deep(.icon) {
  //   width: 28px;
  //   height: 28px;
  // }
}

.placeholder {
  width: 100%;
  height: 100%;
  background-color: $display-neutrals-100;
  border: 1px solid $display-neutrals-300;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(.icon) {
    color: $disabledText;
    width: 28px;
  }
}

.info {
  flex: 1;
  min-width: 0;
}

.status {
  font-size: 14px;
  color: $bodyText;
  margin: 0;
  @include textTruncate(1);
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  &.is-spinning {
    animation: spin 1s linear infinite;
  }

  :deep(.icon) {
    display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>


